/* Copyright (c) 2020 Paul Nebel */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { obj as EventButton, mapDispatchToProps } from './event-button';

class EventIconButton extends EventButton {
    addButtonContents() {
        return (
            <i className={ `fas fa-${this.props.icon} is-size-5 mt-1` }></i>
        );
    }
}

EventIconButton.propTypes = {
    ...EventButton.propTypes,
    icon: PropTypes.string,
};

EventIconButton.defaultProps = {
    ...EventButton.defaultProps,
    icon: 'circle',
    mapDispatchToProps,
};

export const component = connect(
    null,
    mapDispatchToProps,
)(EventIconButton);

export const obj = EventIconButton;
